'use strict';

import angular from 'angular';
import 'angular-ui-router';

angular.module('loginModule.grandfather', ['ui.router'])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('appsoup', {
                abstract: true,
                template: '<ui-view></ui-view>',
                resolve: {
                    'login': ['loginService', '$q', '$http', 'AppsoupAPI', function (loginService, $q, $http, AppsoupAPI) {
                        const roleDefined = $q.defer();

                        /**
                         * In case there is a pendingStateChange means the user requested a $state,
                         * but we don't know yet user's userRole.
                         *
                         * Calling resolvePendingState makes the loginService retrieve his userRole remotely.
                         *
                         * We also need to check for a token on page reload when pendingStateChange is null.
                         */
                        const userToken = localStorage.getItem('appsoup:userToken');

                        if (loginService.pendingStateChange || userToken) {
                            return loginService.resolvePendingState($http.get(`${AppsoupAPI.API_URL}/auth-check`));
                        } else {
                            roleDefined.resolve();
                        }

                        return roleDefined.promise;
                    }]
                },
                ncyBreadcrumb: {
                    label: 'HOME'
                }
            });
    }]);

export default angular.module('loginModule.grandfather');
